<template>
  <div class="columns">
    <div class="column">
      <label class="label">Yours</label>
      <ul>
        <li v-for="(item, idx) in labeledLocal" :key="'local-' + idx">
          <span class="is-family-monospace">
            <strong>{{ item.label }}:</strong>
            {{ item.value || 'N/A' }}
          </span>
        </li>
      </ul>
    </div>

    <div class="column">
      <label class="label">Theirs</label>
      <ul>
        <li v-for="(item, idx) in labeledServer" :key="'server-' + idx">
          <span class="is-family-monospace">
            <strong>{{ item.label }}:</strong>
            {{ item.value || 'N/A' }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictMeasurementsField',
  props: {
    localEntity: {
      type: Object,
      default: () => ({}),
    },
    serverEntity: {
      type: Object,
      default: () => ({}),
    },
    local: {
      type: Array,
      default: () => [],
    },
    server: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    labeledLocal() {
      return this.getLabeledMeasurements(this.local, 'local');
    },
    labeledServer() {
      return this.getLabeledMeasurements(this.server, 'server');
    },
  },
  methods: {
    isRunoutSingle(entity) {
      return entity.type === 'runout' && entity.multipleMeasurements === false;
    },
    isRunoutMultiple(entity) {
      return entity.type === 'runout' && entity.multipleMeasurements === true;
    },
    isVisualMeasurement(entity) {
      return entity.type === 'visual';
    },
    getLabeledMeasurements(source, sourceType) {
      // eslint-disable-next-line no-unused-vars
      const fullEntity =
        sourceType === 'local' ? this.localEntity : this.serverEntity;

      if (this.isRunoutSingle(fullEntity)) {
        return source.map((item, idx) => {
          let label;
          let value =
            item?.value !== undefined && item?.value !== null
              ? `${item.value}`
              : undefined;
          if (idx === 0) {
            label = 'TIR';
          } else if (idx === 1) {
            label = 'Pos';
            value = `${value}°`;
          } else {
            label = `Deg ${idx + 1}`;
          }
          return {
            label,
            value,
          };
        });
      }

      if (this.isRunoutMultiple(fullEntity)) {
        const total = source.length;
        return source.map((item, idx) => {
          const angle = (360 / total) * idx;
          return {
            label: `${Math.round(angle) % 360} deg`,
            value: item?.value,
          };
        });
      }

      if (this.isVisualMeasurement(fullEntity)) {
        const isAcceptable = fullEntity.measurements.every(
          (measurement) => measurement.value === ''
        );

        if (isAcceptable) {
          return [
            {
              label: 'Visual',
              value: 'Acceptable',
            },
          ];
        }

        const visualValues = ['Rubbed', 'Damaged', 'Pitted', 'Eroded'];
        return source.map((item, idx) => {
          return {
            label: `${visualValues[idx]}`,
            value: item?.value
              ? item.value.charAt(0).toUpperCase() + item.value.slice(1)
              : item?.value,
          };
        });
      }

      if (!fullEntity.multipleMeasurements) {
        return [
          {
            label: 'Pos1',
            value: fullEntity.measurements[0].value,
          },
        ];
      }

      return source.map((item, idx) => ({
        label: `Pos${idx + 1}`,
        value: item?.value,
      }));
    },
  },
};
</script>

<style scoped>
ul {
  margin: 0;
  padding-left: 1em;
}
li {
  list-style: none;
}
</style>
